import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserService } from "../../services/User.service";

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    setError(null);

    try {

      const res= await UserService.sendPasswordReset(email);
      setMessage(
        "Si este correo está registrado, recibirás un enlace para restablecer tu contraseña."
      );
    } catch (err) {
      setError("Ocurrió un error. Por favor, intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.formContainer}>
        <h1 style={styles.title}>Recuperar Contraseña</h1>
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Correo Electrónico:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            style={styles.buttonPrimary}
          >
            {loading ? "Enviando..." : "Enviar Enlace"}
          </button>
        </form>
        {message && <p style={styles.success}>{message}</p>}
        {error && <p style={styles.error}>{error}</p>}
        <button
          onClick={() => navigate("/login")}
          style={styles.buttonSecondary}
        >
          Volver al Inicio de Sesión
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f5f5f5",
  },
  formContainer: {
    padding: "2rem",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    textAlign: "center" as const,
  },
  title: {
    marginBottom: "1rem",
    fontSize: "24px",
    fontWeight: "bold",
  },
  form: {
    marginBottom: "1rem",
  },
  inputGroup: {
    marginBottom: "1rem",
  },
  label: {
    display: "block",
    marginBottom: "0.5rem",
    fontSize: "14px",
    fontWeight: "bold",
  },
  input: {
    width: "100%",
    padding: "0.5rem",
    borderRadius: "4px",
    border: "1px solid #ccc",
    fontSize: "14px",
  },
  buttonPrimary: {
    width: "100%",
    padding: "0.5rem",
    borderRadius: "4px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    fontWeight: "bold",
  },
  buttonSecondary: {
    width: "100%",
    padding: "0.5rem",
    borderRadius: "4px",
    backgroundColor: "#6c757d",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    marginTop: "0.5rem",
    fontWeight: "bold",
  },
  success: {
    color: "green",
    fontSize: "14px",
    marginTop: "1rem",
  },
  error: {
    color: "red",
    fontSize: "14px",
    marginTop: "1rem",
  },
};

export default ForgotPasswordPage;
